module.exports = flarum.core.compat['utils/extractText'];